import { useState, useEffect } from 'react';

function TypingText({ words, typingSpeed = 150, deletingSpeed = 100, pauseTime = 2000 }) {
    const [text, setText] = useState('');
    const [wordIndex, setWordIndex] = useState(0);
    const [isDeleting, setIsDeleting] = useState(false);

    useEffect(() => {
        const currentWord = words[wordIndex];

        const timeout = setTimeout(() => {
            if (!isDeleting) {
                setText(currentWord.substring(0, text.length + 1));

                if (text === currentWord) {
                    setTimeout(() => setIsDeleting(true), pauseTime);
                }
            } else {
                setText(currentWord.substring(0, text.length - 1));

                if (text === '') {
                    setIsDeleting(false);
                    setWordIndex((prev) => (prev + 1) % words.length);
                }
            }
        }, isDeleting ? deletingSpeed : typingSpeed);

        return () => clearTimeout(timeout);
    }, [text, isDeleting, wordIndex, words, typingSpeed, deletingSpeed, pauseTime]);

    return (
        <span style={{ borderRight: '2px solid #333', paddingRight: '5px' }}>
      {text}
    </span>
    );
}

export default TypingText;